import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import { OrderType, PaymentMethod, PaymentStatus } from 'interfaces';

export type Order = {
  order_id?: number; // 주문 idx
  user_id?: number; // 유저 idx
  shop_information_id?: number;
  product_information?: { [key: string]: string | number }[]; // 상품정보
  principal?: number; // 원금
  final_discount?: number; // 최종 할인 금액
  final_reward_point?: number; // 최종 적립 금액
  final_price?: number; // 최종 결제 금액
  amount?: number; // 수량
  rating_discount_rate?: number; // 등급할인율
  rating_reward_rate?: number; // 등급적립률
  rating_name?: string; // 등급명
  group_id?: number; // 등급 idx
  product_policy_JSON?: { [key: string]: Record<string, any> }; // 상품정책 JSON
  payment_state?: (typeof PaymentStatus)[keyof typeof PaymentStatus]; // 결제 상태
  type?: (typeof OrderType)[keyof typeof OrderType]; // 타입
  toss_id?: number; // 토스 id
  payment_method?: (typeof PaymentMethod)[keyof typeof PaymentMethod]; // 결제 수단
  payment_completion_date?: number; // 결제 완료일
  created_at?: number; // 생성일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Order
   * --
   */
  getOrders: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_ORDER, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Order
   * --
   */
  getOrder: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_ORDER, { order_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Order
   * --
   */
  createOrder: async (body: Order) => {
    try {
      const res = await $http.post(APIConstant.CREATE_ORDER, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Order
   * --
   */
  updateOrder: async (body: Order) => {
    try {
      const { order_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_ORDER, {
        order_id: order_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Order
   * --
   */
  updateStatusOrder: async (body: Order) => {
    try {
      const { order_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_STATUS_ORDER, {
        order_id: order_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Order
   * --
   */
  deleteOrder: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_ORDER, {
        order_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GETS] Guest Order
   * --
   */
  getGuestOrder: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GET_GUEST_ORDER, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Order
   * --
   */
  createManualOrder: async (body: Order) => {
    try {
      const res = await $http.post(APIConstant.CREATE_MANUAL_ORDER, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Order
   * --
   */
  upsertOrder: async (body: Order[]) => {
    try {
      const res = await $http.bulk(APIConstant.UPSERT_ORDER, body, 'PUT');
      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
